import React, { useState, useEffect } from 'react';
import profileService from '../../../services/profileService';

export const ProfileTestPreviewModal = ({ profile, onClose }) => {
  const [components, setComponents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!profile) return;

    // If profile already contains preloaded components/tests
    if (profile.components && Array.isArray(profile.components) && profile.components.length > 0) {
      setComponents(profile.components);
      setLoading(false);
      return;
    }

    let isMounted = true;
    const fetchComponents = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await profileService.getProfileComponents(profile.profileId);
        if (isMounted) {
          if (res && res.success) {
            setComponents(res.data || []);
          } else {
            setComponents([]);
          }
        }
      } catch (err) {
        if (isMounted) {
          setError('Unable to load components for this profile.');
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchComponents();
    return () => {
      isMounted = false;
    };
  }, [profile]);

  if (!profile) return null;

  return (
    <div className="pkg-modal-backdrop" onClick={onClose} role="dialog" aria-modal="true">
      <div className="pkg-preview-modal fade-in" onClick={(e) => e.stopPropagation()}>
        <div className="pkg-modal-header">
          <div className="pkg-modal-title-group">
            <span className="pkg-badge-profile">PROFILE PREVIEW</span>
            <h3 className="pkg-modal-title">{profile.profileName || profile.name}</h3>
            <span className="pkg-modal-subtitle">
              Code: <strong>{profile.profileCode || profile.code || '—'}</strong> • Contained Tests: <strong>{components.length}</strong>
            </span>
          </div>
          <button type="button" className="pkg-modal-close" onClick={onClose} aria-label="Close modal">
            ✕
          </button>
        </div>

        <div className="pkg-modal-body">
          {loading ? (
            <div className="pkg-loading-state">
              <div className="pkg-spinner"></div>
              <span>Loading included profile tests...</span>
            </div>
          ) : error ? (
            <div className="pkg-empty-state error">
              <span>{error}</span>
            </div>
          ) : components.length === 0 ? (
            <div className="pkg-empty-state">
              <span>No tests configured in this profile yet.</span>
            </div>
          ) : (
            <div className="pkg-test-preview-list">
              <div className="pkg-preview-list-header">
                <span>Included Clinical Tests ({components.length})</span>
                <span className="pkg-preview-hint">All these tests will be ordered with the package</span>
              </div>
              <div className="pkg-preview-grid">
                {components.map((c, idx) => (
                  <div key={c.id || c.investigationId || idx} className="pkg-preview-item">
                    <span className="pkg-preview-check">✓</span>
                    <div className="pkg-preview-details">
                      <span className="pkg-preview-test-name">{c.investigationName || c.name || c.testCode}</span>
                      <span className="pkg-preview-test-code">
                        Code: {c.testCode || '—'} {c.departmentName ? `• ${c.departmentName}` : ''}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="pkg-modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Close Preview
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileTestPreviewModal;
